import React from 'react';
import Modal from './Modal';
import Button from './Button';

const PendingChargeModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      name="pending-charge"
      isOpen={isOpen}
      onClose={onClose}
      title="Your Order Is Being Processed"
      description="Please check back in a few minutes."
      closeOnBackdropClick={false}
    >
      <div className="space-y-4 text-center">
        <div className="flex justify-center mb-4">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-16 w-16 text-[#FF6247]" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
        </div>
        <p className="text-gray-600 text-sm">
          Your subscription cannot be modified at the moment because there is a pending charge that's being processed.
        </p>
        <p className="text-gray-500 text-sm">
          Please try again in a few minutes once the charge has completed.
        </p>

        <Button
          variant="primary"
          fullWidth
          onClick={onClose}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
};

export default PendingChargeModal;
